export const steps = [
  {
    number: '01',
    title: 'Plan',
    description: 'Drop in a destination and your dates — RoamMyWay drafts a full itinerary in minutes.',
    icon: 'calendar',
  },
  {
    number: '02',
    title: 'Refine',
    description: 'Swap stops, shift the pace, and fine-tune the plan with anyone joining the trip.',
    icon: 'sync',
  },
  {
    number: '03',
    title: 'Book',
    description: 'Compare flights, stays and activities side by side, then book without leaving your plan.',
    icon: 'link',
  },
]

export const features = [
  {
    icon: 'clock',
    title: 'Built Around Your Time',
    description:
      'RoamMyWay balances must-see stops with real breathing room, so full days never feel rushed — all inside the budget you set.',
  },
  {
    icon: 'people',
    title: 'Plan It Together',
    description:
      'Add your travel companions to the trip and every change updates for everyone at once — no more group chats full of screenshots.',
  },
  {
    icon: 'tag',
    title: 'Fair Prices, No Digging',
    description:
      'We compare flights, stays and activities across trusted partners automatically, multi-city routes included, so the best rate turns up on its own.',
  },
]
